module.exports = __webpack_public_path__ + "static/media/242 Park - Concept Drawing 3.42c9288c.jpg";